module.exports = __webpack_public_path__ + "img/logo.7116ffa7.png";